<div class="verify-component">
  <h1 class="text-title-4 mb-8" role="heading">
    <img
      [src]="'./idp/__default/assets/images/' + type + '.png'"
      class="mr-16 mr-sm-8 verify-icon"
      alt=""
    />
    <span >{{
      'rogers.' + type + '.mainHeader' | translate
    }}</span>
  </h1>
  <p
    class="text-body-lg mb-24"
    [innerHTML]="
      'rogers.' + type + '.mainMessage'
        | translate
          : {
              value: type === 'verifyEmail' ? email : (ctn)
            }
    "
  ></p>
  <ng-container ssTrackEvent [event]="track.pageLoad"></ng-container>
  <ng-container
    *ngIf="resendCodeClick"
    ssTrackEvent
    [event]="track.resendCode"
  ></ng-container>

  <form
    [formGroup]="verifyUserForm"
    autocomplete="off"
    (submitDirective)="onSubmit()"
    preventSubmitDirective
  >
    <ds-alert
      variant="error"
      [closeLabel]="'rogers.login.popOverClose' | translate"
      (closeClick)="resetErrorMessage()"
      class="mb-16"
      *ngIf="!!apiErrorTranslationKey"
      ssTrackEvent
      [event]="track.invalidCodeError"
      role="alert"
    >
      <div class="d-flex flex-column flex-md-row">
        <div class="flex-grow-1 d-flex">
          <ds-icon
            class="mr-8"
            name="error-outlined"
            color="error"
            [ariaHidden]="false"
            caption="Attention"
            [attr.title]="'rogers.login.accessibility.error' | translate"
          ></ds-icon>
          <div>
            <span
              damTranslationWithRouting
              class="text-body mb-0 mw-content"
              [innerHTML]="apiErrorTranslationKey | translate"
            ></span>
          </div>
        </div>
      </div>
    </ds-alert>
    <div
      class="mb-16 code-input-container"
      [ngClass]="{
        'otp-invalid': formSubmitted && otpFieldIsInvalid
      }"
    >
      <ds-code-input
        [a11yLabel]="'rogers.verifyEmail.verificationInput' | translate"
        [length]="6"
        #codeInputRef
        (codeChanged)="onCodeChanged()"
        (codeCompleted)="onCodeCompleted($event)"
      >
      </ds-code-input>
      <ds-error
        [errorMessage]="'rogers.verifySms.error.enterCode' | translate"
        *ngIf="formSubmitted && otpFieldIsInvalid"
        ssTrackEvent
        [event]="track.formValidationError"
        role="alert"
      ></ds-error>
    </div>
    <div>
      <div class="text-body-md mb-32 mt-16 d-flex flex-wrap">
        <p
          class="text-body-md pt-12 mr-4"
          [innerHTML]="'rogers.' + type + '.didntGet' | translate"
        ></p>
        <ng-container
          [counter]="counterInitialValue"
          (value)="onCounterChange($event)"
        >
          <button
            ds-button
            variant="tertiary"
            (click)="onResendCode()"
            [disabled]="resendDisabled"
            [attr.aria-disabled]="resendDisabled"
            [attr.aria-label]="
              'rogers.' + type + '.accessibility.resendCode' | translate
            "
            [attr.title]="
              'rogers.' + type + '.accessibility.resendCode' | translate
            "
          >
            <span
              class="text-body-lg"
              [innerHTML]="'common.resendCode' | translate"
            >
            </span>
            <ds-icon *ngIf="counter === 0" name="chevron-right"></ds-icon>
            <span
              *ngIf="counter > 0"
              class="ml-8 text-body-lg otp-timer"
              [innerHTML]="'common.timer' | translate: { counter: counter }"
            >
            </span>
          </button>
        </ng-container>
        <div
          *ngIf="showChangeEmailOption()"
        >
          <span class="mr-8 text-semi mt-16">{{
            'rogers.verifyEmail.or' | translate
          }}</span>
          <button
            ds-button
            variant="tertiary"
            (click)="onChangeEmailAddress()"
            [attr.aria-label]="
              'rogers.verifyEmail.accessibility.changeToEmail' | translate
            "
            [attr.title]="
              'rogers.verifyEmail.accessibility.changeToEmail' | translate
            "
          >
            <span
              class="text-body-lg"
              [innerHTML]="'rogers.verifyEmail.changeEmailAddress' | translate"
            >
            </span>
            <ds-icon *ngIf="counter === 0" name="chevron-right"></ds-icon>
          </button>
        </div>
      </div>
    </div>

    <button
      ds-button
      class="w-100 mb-16"
      [attr.title]="'common.accessibility.continue' | translate"
    >
      <span *ngIf="!verifyUserInProgress">{{
        'common.continue' | translate
      }}</span>
      <eas-loader class="loader" *ngIf="verifyUserInProgress"></eas-loader>
    </button>
  </form>
  <button
      ds-button
      variant="secondary"
      class="w-100 mb-16"
      (click)="onSkip()"
      *ngIf="flow === 'set-recovery-number'"
      [attr.title]="'rogers.setPhoneNumber.btnSkip' | translate"
    >
      <span *ngIf="!verifyUserInProgress">{{
        'rogers.setPhoneNumber.btnSkip' | translate
      }}</span>
    </button>
  <div
    *ngIf="
      type === 'verifyEmail' || !!!this.email;
      then verifyByEmailFooter;
      else verifyBySmsFooter
    "
  ></div>
  <ng-template #verifyByEmailFooter>
    <div class="d-flex ds-bgcolor-fog verify-email-footer">
      <div
        class="verify-email-footer__content d-flex flex-wrap text-body-lg"
        *ngIf="flow"
      >
        <ng-container [ngSwitch]="flow">
          <div
            *ngSwitchCase="'set-recovery-number'"
            class="text-body-lg pt-8  mr-4"
            style="margin-top: 2px;"
          >
            {{ 'rogers.setPhoneNumber.footer.text' | translate }}
            <button
              ds-button
              variant="tertiary"
              (click)="onEditRecoveryNumber()"
            >
              <span
                class="text-body-lg  text-semi"
                (click)="onEditRecoveryNumber()"
                [innerHTML]="'rogers.setPhoneNumber.footer.link' | translate"
              ></span
              ><ds-icon name="chevron-right"></ds-icon>
            </button>
          </div>
          <div *ngSwitchCase="'shield'" class="mb-24 mt-24">
            {{ 'rogers.verifyEmail.footertextNeedHelp' | translate }}
            <span
              class="text-body-lg pt-8  mr-4"
              [innerHTML]="'rogers.contactUsForAssistance' | translate"
            ></span>
          </div>
          <div
            class="text-body-lg pt-8  mr-4"
            style="margin-top: 2px;"
            *ngSwitchDefault
          >
            {{ 'rogers.verifyEmail.footerText' | translate }}
            <app-livechat
              [altText]="
                'rogers.verifyEmail.accessibility.liveChat' | translate
              "
              [buttonClass]="'common.forgotLiveChat.cbid' | translate"
              [boldChatButtonId]="'accountRecovery'"
              [translateCBID]="'common.forgotLiveChat.cbid' | translate"
              [isHidden]="true"
            >
              <button
                ds-button
                (click)="onLiveChat()"
                variant="tertiary"
                [attr.aria-label]="
                  'rogers.verifyEmail.accessibility.liveChat' | translate
                "
                [attr.title]="
                  'rogers.verifyEmail.accessibility.liveChat' | translate
                "
              >
                <span class="text-body-lg  text-semi">
                  {{ 'rogers.verifyEmail.footerLink' | translate }}</span
                >
                <ds-icon *ngIf="!isFido" name="chevron-right"></ds-icon>
              </button>
            </app-livechat>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template #verifyBySmsFooter>
    <div
      class="ds-border-bottom mb-lg-24 mb-sm-0 mt-16 ds-brcolor-concrete"
      *ngIf="!!email"
    ></div>
    <div class="d-flex flex-wrap text-body-lg" *ngIf="!!email">
      <p class="text-body-lg pt-8 mr-4 mb-0" style="margin-top: 2px;">
        {{ 'rogers.verifySms.footerText' | translate }}
      </p>
      <button
        ds-button
        variant="tertiary"
        (click)="onSendCodeByEmail()"
        [disabled]="maxResendAttempts"
        [attr.aria-disabled]="maxResendAttempts"
        [attr.aria-label]="
          'rogers.verifySms.accessibility.sendToEmail' | translate
        "
        [attr.title]="'rogers.verifySms.accessibility.sendToEmail' | translate"
      >
        <span class="text-body-lg ">
          {{ 'rogers.verifySms.footerLink' | translate }}</span
        >
        <ds-icon name="chevron-right"></ds-icon>
      </button>
    </div>
  </ng-template>
</div>
